import ContentProfessional from '../components/professional/content'

export default {
  ContentProfessional
}



// WEBPACK FOOTER //
// ./src/app/professional/loading-page/gadget/resources/components.js